import { useMemo, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import ConfirmBookingModal from './ConfirmBookingModal';
import CancelBookingModal from './CancelBookingModal';
import AlternativeProposalModal from './AlternativeProposalModal';

const editableStatuses = ['PENDING', 'REQUESTED'];

const SupplierActionsCard = ({
    booking,
    submitting,
    onConfirm,
    onCancel,
    onAlternative,
}) => {
    const [showConfirm, setShowConfirm] = useState(false);
    const [showCancel, setShowCancel] = useState(false);
    const [showAlternative, setShowAlternative] = useState(false);

    const canTakeAction = useMemo(() => {
        return editableStatuses.includes(booking.status);
    }, [booking.status]);

    return (
        <>
            <Card className="shadow-sm border-0">
                <Card.Header className="bg-white fw-semibold">Actions</Card.Header>
                <Card.Body className="d-grid gap-2">
                    <Button
                        variant="success"
                        disabled={!canTakeAction || submitting}
                        onClick={() => setShowConfirm(true)}
                    >
                        Confirm Booking
                    </Button>

                    <Button
                        variant="warning"
                        disabled={!canTakeAction || submitting}
                        onClick={() => setShowAlternative(true)}
                    >
                        Offer Alternative
                    </Button>

                    <Button
                        variant="danger"
                        disabled={!canTakeAction || submitting}
                        onClick={() => setShowCancel(true)}
                    >
                        Decline Booking
                    </Button>
                </Card.Body>
            </Card>

            <ConfirmBookingModal
                show={showConfirm}
                loading={submitting}
                onClose={() => setShowConfirm(false)}
                onSubmit={async () => {
                    await onConfirm();
                    setShowConfirm(false);
                }}
            />

            <CancelBookingModal
                show={showCancel}
                loading={submitting}
                onClose={() => setShowCancel(false)}
                onSubmit={async (payload) => {
                    await onCancel(payload);
                    setShowCancel(false);
                }}
            />

            <AlternativeProposalModal
                show={showAlternative}
                loading={submitting}
                motorcycleOptions={booking.shopMotorcycles}
                onClose={() => setShowAlternative(false)}
                onSubmit={async (payload) => {
                    await onAlternative(payload);
                    setShowAlternative(false);
                }}
            />
        </>
    );
};

export default SupplierActionsCard;